export function statusTextForTask(task: sage.model.ITask): string {
    switch (task.curr_state) {
        case "CREATED":
            return "Created";
        case "DEQUEUED":
            return "Dequeued";
        case "DOWNLOADING_DATA":
            return "Downloading Data";
        case "DOWNLOADING_REQUIREMENTS":
            return "Downloading Requirements";
        case "ERROR":
            return "Error";
        case "FINISHED":
            return "Finished";
        case "QUEUED":
            return "Queued";
        case "RUNNING":
            return `Running ${Math.round(
                task.curr_state_completion_percentage * 100
            )}%`;
        case "UPLOADING_RESULT":
            return `Uploading Result ${Math.round(
                task.curr_state_completion_percentage * 100
            )}%`;
        case "CANCELLED":
            return "Cancelled";
    }
}

export function colorClassForTaskState(
    taskState: sage.model.TaskState
): string {
    switch (taskState) {
        case "CREATED":
        case "QUEUED":
            return "secondary";
        case "ERROR":
            return "danger";
        case "FINISHED":
            return "success";
        case "RUNNING":
        case "UPLOADING_RESULT":
        case "DOWNLOADING_DATA":
        case "DOWNLOADING_REQUIREMENTS":
        case "DEQUEUED":
            return "primary";
        case "CANCELLED":
            return "warning";
        default:
            throw new Error("unknown state count");
    }
}

export function colorClassForTask(task: sage.model.ITask): string {
    return colorClassForTaskState(task.curr_state);
}

export function colorClassForTaskEarned(task: sage.model.ITask): string {
    if (task.counted_time === null) {
        return "warning";
    } else {
        return "success";
    }
}

export function statusTextForTaskEarned(task: sage.model.ITask): string {
    if (task.counted_time === null) {
        return "Pending";
    } else {
        return "Counted";
    }
}
